const FAQs = [
	{
		question: "Why Nexcaliber over another TPA?",
		answer: "You’re working with a boutique administrator that has decades of experience with all size groups from small to 2,500 lives so we know how to set up plans that allow you more control for less expense and we share the risk."
	},
	{
		question: "Why is Nexcaliber less expensive?",
		answer: "Three reasons.  First, it provides a closed-loop, automated system that channels claims through a simple, in-house system and settles them with aggressive risk-share (savings of claims) management.  Next, We have negotiated rates not too much above Medicare for our networks.  Finally, clients are royalty and we’re not greedy."
	},
	{
		question: "Why Nexcaliber over another TPA?",
		answer: "You’re working with a boutique administrator that has decades of experience with all size groups from small to 2,500 lives so we know how to set up plans that allow you more control for less expense and we share the risk."
	},
	{
		question: "Why is Nexcaliber less expensive?",
		answer: "Three reasons.  First, it provides a closed-loop, automated system that channels claims through a simple, in-house system and settles them with aggressive risk-share (savings of claims) management.  Next, We have negotiated rates not too much above Medicare for our networks.  Finally, clients are royalty and we’re not greedy."
	},
	{
		question: "Why Nexcaliber over another TPA?",
		answer: "You’re working with a boutique administrator that has decades of experience with all size groups from small to 2,500 lives so we know how to set up plans that allow you more control for less expense and we share the risk."
	},
	{
		question: "Why is Nexcaliber less expensive?",
		answer: "Three reasons.  First, it provides a closed-loop, automated system that channels claims through a simple, in-house system and settles them with aggressive risk-share (savings of claims) management.  Next, We have negotiated rates not too much above Medicare for our networks.  Finally, clients are royalty and we’re not greedy."
	}
];

export const FAQS = FAQs;
